export default __webpack_public_path__ + "static/media/sector_3.a05c6217.jpg";